import { render, staticRenderFns } from "./showVisitDetails.vue?vue&type=template&id=3be67723&"
import script from "./showVisitDetails.vue?vue&type=script&lang=js&"
export * from "./showVisitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports